import type { PDFViewer } from 'pdfjs-dist/web/pdf_viewer.mjs';

import { MAX_PDF_SCALE, MIN_PDF_SCALE, PDF_ZOOM_STEP } from './constants';

export type PdfFitMode = 'page-width' | 'page-fit' | null;
export type PdfZoomDirection = 'in' | 'out';

type ZoomablePdfViewer = Pick<
  PDFViewer,
  'currentScale' | 'decreaseScale' | 'increaseScale'
>;

export function getPdfViewerZoomOrigin(
  container: HTMLElement,
  clientX: number,
  clientY: number
): [number, number] {
  const bounds = container.getBoundingClientRect();
  return [
    container.offsetLeft + clientX - bounds.left,
    container.offsetTop + clientY - bounds.top,
  ];
}

export function zoomPdfViewer(
  viewer: ZoomablePdfViewer,
  direction: PdfZoomDirection,
  origin?: [number, number]
) {
  const scaleFactor = direction === 'in' ? PDF_ZOOM_STEP : 1 / PDF_ZOOM_STEP;
  const targetScale = Math.min(
    MAX_PDF_SCALE,
    Math.max(MIN_PDF_SCALE, viewer.currentScale * scaleFactor)
  );

  if (targetScale === viewer.currentScale) {
    return;
  }

  const options = {
    scaleFactor: targetScale / viewer.currentScale,
    ...(origin ? { origin } : {}),
  };
  if (direction === 'in') {
    viewer.increaseScale(options);
  } else {
    viewer.decreaseScale(options);
  }
}
